import React from 'react';

import { Flex } from '@chakra-ui/react';

import { Chip } from 'uiToolkitV1/Chip';

export const ChipSelect = ({
  options,
  selectedIds = [],
  onChange,
  multipleSelect = false,
  forceMinOneSelection = false,
  ...props
}) => {
  const onChangeHandler = (id) => {
    let newSelectedIds = [];

    if (selectedIds.includes(id)) {
      if (multipleSelect) {
        newSelectedIds = selectedIds.filter((prevId) => prevId !== id);
      } else {
        newSelectedIds = [];
      }
    } else if (multipleSelect) {
      newSelectedIds = [...selectedIds, id];
    } else {
      newSelectedIds = [id];
    }

    if (forceMinOneSelection && newSelectedIds.length === 0) {
      return selectedIds;
    }

    onChange(newSelectedIds);
  };

  return (
    <Flex gap={2} wrap={'wrap'} {...props}>
      {options.map(({ id, text, icon }) => (
        <Chip key={id} variant="outlined" selected={selectedIds?.[0]?.includes(id)} onClick={() => onChangeHandler(id)}>
          {icon}
          {text}
        </Chip>
      ))}
    </Flex>
  );
};
